function serializeJsonLd(schema) {
  if (typeof schema !== "string" || !schema.trim()) {
    return null;
  }

  try {
    return JSON.stringify(JSON.parse(schema))
      .replace(/</g, "\\u003c")
      .replace(/>/g, "\\u003e")
      .replace(/&/g, "\\u0026");
  } catch (error) {
    return null;
  }
}

module.exports = serializeJsonLd;
